// Barrel for frank extraction — see context.js note on pages wiring.
// account/index.js + auth/accept-invite.js + auth/waitlist-invite.js: the
// other auth/*.js pages already ride identity-index.js's own re-export
// below, but these three have no path through it — added alongside their
// consumers' deep-subpath fix (tickets/execution-board.md §1: a per-file
// specifier like '@symbo-ls/workspace-shared/pages/auth/accept-invite.js'
// cannot resolve through the platform's public importmap once this package
// is pushed as a library).
export * from './account/index.js'
export * from './auth/accept-invite.js'
export * from './auth/waitlist-invite.js'
export * from './add-branch-modal.js'
export * from './add-canvas-modal.js'
export * from './add-case-modal.js'
export * from './add-cname-modal.js'
export * from './add-color-modal.js'
export * from './add-component-modal.js'
export * from './add-custom-domain-modal.js'
export * from './add-dependency-modal.js'
export * from './add-file-modal.js'
export * from './add-font-family-modal.js'
export * from './add-function-modal.js'
export * from './add-global-theme-modal.js'
export * from './add-icon-modal.js'
export * from './add-method-modal.js'
export * from './add-page-modal.js'
export * from './add-secret-modal.js'
export * from './add-snippet-modal.js'
export * from './add-theme-modal.js'
export * from './browser-extension.js'
export * from './browser-preview.js'
export * from './compile-markdown.js'
export * from './compile-modal.js'
export * from './compile.js'
export * from './edit-branch-modal.js'
export * from './edit-canvas-modal.js'
export * from './edit-case-modal.js'
export * from './edit-color-modal.js'
export * from './edit-component-modal.js'
export * from './edit-dependency-modal.js'
export * from './edit-file-modal.js'
export * from './edit-font-family-modal.js'
export * from './edit-function-modal.js'
export * from './edit-global-theme-modal.js'
export * from './edit-icon-modal.js'
export * from './edit-method-modal.js'
export * from './edit-page-modal.js'
export * from './edit-secret-modal.js'
export * from './edit-snippet-modal.js'
export * from './feedback-modal.js'
export * from './fetch.js'
export * from './grids.js'
export * from './icons.js'
export * from './identity-index.js'
export * from './install.js'
export * from './invite.js'
export * from './lazyPage.js'
export * from './profile.js'
export * from './project-code.js'
export * from './publish-modal.js'
export * from './reset-modal.js'
export * from './settings.js'
export * from './share-modal.js'
export * from './tutorial-modal.js'
export * from './upload-font-modal.js'
export * from './userProfile.js'
export * from './waitlist.js'
export * from './welcome-modal.js'
